export default __webpack_public_path__ + "static/media/about-us.2ebe2cb8.png";